module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/vi_2-f73368c5ef17d4b876a92aa8917eceab.jpg";